import { Button, Col, Form, Input, message, Row, Space } from 'antd';
import React, { Component } from 'react';
import ArticleApi from '../../functions/api/cms/ArticleApi';
import CountryApi from '../../functions/api/cms/CountryApi';
import { CustomSelect } from '../booking/form/CustomSelect';

const { TextArea } = Input;
const formItemLayout = {
  wrapperCol: { span: 24 },
  labelCol: { span: 24 },
};

class FormArticle extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isEdit: false,
      article: null,
      countries: [],
    };
  }

  formRef = React.createRef();

  componentDidMount = async () => {
    const { match } = this.props;

    if (match.params && match.path === '/article/edit-article/:id/:lang') {
      const { id, lang } = match.params;
      const article = await ArticleApi.detail(id, lang);

      this.formRef.current.setFieldsValue({ title: article.title });
      this.formRef.current.setFieldsValue({ language: article.language });
      this.formRef.current.setFieldsValue({ content: article.content });

      this.setState({
        isEdit: true,
        article,
      });
    }

    const countries = await CountryApi.index();

    this.setState({ countries });
  };

  submitForm = async (values) => {
    try {
      const { isEdit, article } = this.state;
      let result;

      if (isEdit) {
        result = await ArticleApi.edit(article.id, article.language, values);
      } else {
        result = await ArticleApi.create(values);
      }

      if (null !== result) {
        message.success(`Đã lưu bài viết ${result.title}`);
        this.props.history.push('/article');
      }
    } catch (error) {
      console.error(error);
    }
  };

  render() {
    const { isEdit, article, countries } = this.state;
    return (
      <>
        <h1>{isEdit ? `Sửa bài viết ${article.title}` : 'Thêm bài viết'}</h1>
        <Form
          {...formItemLayout}
          className="bg-grey"
          onFinish={this.submitForm}
          ref={this.formRef}
        >
          <Row gutter={16}>
            <Col span={6}>
              <Form.Item
                name={['title']}
                label="Tiêu đề"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name={['language']}
                label="Ngôn ngữ"
                rules={[{ required: true }]}
              >
                <CustomSelect
                  dataSource={countries}
                  labelField="short_name"
                  valueField="code"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={30}>
              <Form.Item
                name={['content']}
                label="Nội dung"
                rules={[{ required: true }]}
              >
                <TextArea cols="150" rows="20" />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Space>
              <Button htmlType="submit" type="primary">
                Lưu
              </Button>
              <Button type="default" onClick={() => this.props.history.go(-1)}>
                Quay lại
              </Button>
            </Space>
          </Row>
        </Form>
      </>
    );
  }
}

export default FormArticle;
